import { PropTypes } from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import BasePreviewStudy from '../../../../core/components/base-preview-study';
import { setTemplateValues } from '../../../../core/actions';

const TemplatePreviewStudy = ({ templateValues }) => (
  <BasePreviewStudy
    questionSource={templateValues}
    error={null}
    loading={false}
  />
);

const mapStateToProps = ({ templates }) => ({
  templateValues: templates.templateValues,
});

const mapDispatchToProps = {
  onSetTemplateValues: setTemplateValues,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
);

TemplatePreviewStudy.propTypes = {
  templateValues: PropTypes.shape({

  }).isRequired,
};

export default enhance(TemplatePreviewStudy);
